import { useStore } from '../store';
import { translations, type Language } from './translations';

export function useTranslation() {
  const language = useStore((state) => state.language);

  const t = (key: string, params?: Record<string, string | number>): string => {
    // Split the key by dots to access nested properties
    const keys = key.split('.');
    let value: any = translations[language];

    // Navigate through the nested object
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Fallback to English if key not found
        let fallback: any = translations.en;
        for (const fk of keys) {
          if (fallback && typeof fallback === 'object' && fk in fallback) {
            fallback = fallback[fk];
          } else {
            // If even English doesn't have the key, return the key itself
            console.warn(`Translation missing for key: ${key}`);
            return key;
          }
        }
        value = fallback;
        break;
      }
    }

    // If the final value is not a string, return the key
    if (typeof value !== 'string') {
      console.warn(`Translation key does not resolve to string: ${key}`);
      return key;
    }

    // Handle parameter interpolation
    if (params) {
      return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey]?.toString() || match;
      });
    }

    return value;
  };

  return { t, language };
}

// Utility function for getting translations outside of React components
export function getTranslation(key: string, language: Language, params?: Record<string, string | number>): string {
  const keys = key.split('.');
  let value: any = translations[language];

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      let fallback: any = translations.en;
      for (const fk of keys) {
        if (fallback && typeof fallback === 'object' && fk in fallback) {
          fallback = fallback[fk];
        } else {
          return key;
        }
      }
      value = fallback;
      break;
    }
  }

  if (typeof value !== 'string') {
    return key;
  }

  if (params) {
    return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey]?.toString() || match;
    });
  }

  return value;
}